import TechnicalDataView from './TechnicalDataView'
import technicalDataTabContainer from '../technical-data-tab/technicalDataTabContainer'

export default technicalDataTabContainer(TechnicalDataView)
